// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card[data-v-5662d243]{position:relative;height:80vh;width:80vw;padding:40px}.close-button[data-v-5662d243]{position:absolute;top:10px;right:10px}.video-container[data-v-5662d243]{height:100%;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
